import { combineReducers } from 'redux';

import {
  DOMAINS_PLATFORMS_TREE_CHILDREN_KEY,
  DOMAINS_PLATFORMS_TREE_PARENT_KEY,
} from '../../../../../config/testPurchaseConfiguration';
import domainId from './domainId';
import domainPlatformId from './domainPlatformId';
import filterBy from './filterBy';

const selected = combineReducers({
  domainId,
  domainPlatformId,
  filterBy,
});

export default selected;

export const getTestPurchaseFiltersSelectedAllDomainIds = (
  { domainPlatformId = [], domainId = [] },
  domains = []
) =>
  domains.reduce(
    (allDomainIds, { domainPlatform, domains }) => {
      if (domainPlatformId.includes(domainPlatform.domainPlatformId)) {
        allDomainIds.push(...domains.map(({ domainId }) => domainId));
      }
      return allDomainIds;
    },
    [...domainId]
  );

export const getTestPurchaseFiltersSelectedTreeData = ({
  domainPlatformId,
  domainId,
}) => {
  const domainPlatforms = domainPlatformId.map(
    id => `${DOMAINS_PLATFORMS_TREE_PARENT_KEY}_${id}`
  );

  const domains = domainId.map(
    id => `${DOMAINS_PLATFORMS_TREE_CHILDREN_KEY}_${id}`
  );

  return domainPlatforms.concat(domains);
};
